import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from 'src/app/core/config/configuration.service';
import { HttpParamsFromListRequestDTO, ListRequestDTO, ListResponseDTO } from '..';

@Injectable()
export class OrdersBaseProxy {
    constructor(private http: HttpClient, private configurationService: ConfigurationService) {}

    async get(
        options: ListRequestDTO & {
            labNumber?: string;
            excludeChairOrders?: boolean;
            practiceId?: string;
            onlyCanBeReceived?: boolean;
        }
    ): Promise<ListResponseDTO<OrderBaseSummaryDTO>> {
        const url = this.configurationService.APIURL + '/api/orders-base';
        let params = HttpParamsFromListRequestDTO(options);
        if (options.labNumber) {
            params = params.append('labNumber', String(options.labNumber));
        }
        if (options.excludeChairOrders) {
            params = params.append('excludeChairOrders', String(true));
        }
        if (options.practiceId) {
            params = params.append('practiceId', String(options.practiceId));
        }
        if (options.onlyCanBeReceived) {
            params = params.append('onlyCanBeReceived', String(true));
        }
        return this.http.get<ListResponseDTO<OrderBaseSummaryDTO>>(url, { params: params }).toPromise();
    }

    async receive(ordersBase: { id: string; sampleDate: Date | string | null }[]): Promise<object> {
        const url = this.configurationService.APIURL + '/api/orders-base/receive';
        return await this.http.put(url, { ordersBase: ordersBase }).toPromise();
    }

    parseInstrumentFile(formData: FormData): Observable<any> {
        const url = this.configurationService.APIURL + '/api/orders-base/instrument-file';
        return this.http.post(url, formData, {
            reportProgress: true,
            observe: 'events',
        });
    }
}

export interface OrderBaseSummaryDTO {
    id: string;
    practiceId: string;
    practiceName: string;
    labNumber: string;
    reference: string;
    testName: string;
    testPrimaryColorHex: string;
    testSecondaryColorHex: string;
    canBeReceived: boolean;
    canAddResult: boolean;
    isChairOrder: boolean;
}
